import React from 'react';
import { useTranslation } from 'shared/contexts/I18nContext';
import { useSubscription } from 'shared/contexts/Subscription';
import { mockSubscriptionPlans } from "shared/services/mockData";
import ContentHeaderSection from 'shared/common/ContentHeaderSection';

const SubscriptionPlans = ({ navigateTo }) => {
    const { t } = useTranslation();
    const { currentSubscriptionLevel, setCurrentSubscriptionLevel } = useSubscription();

    const handleSelectPlan = (planName) => {
        setCurrentSubscriptionLevel(planName);
        navigateTo('home');
    };

    const formatLimit = (limit) => {
        return limit === Infinity ? t('unlimited') : limit;
    };

    const features = [
        { key: 'maxStudents', label: 'studentsLimit' },
        { key: 'maxCourses', label: 'coursesLimit' },
        { key: 'maxBatchesPerCourse', label: 'batchesLimit' },
        { key: 'maxStudentsPerTutor', label: 'studentsPerTutorLimit' },
    ];

    const planKeys = Object.keys(mockSubscriptionPlans);

    return (
        <div className="p-8 md:px-10">
            <ContentHeaderSection
                title={t('subscriptionPlans')}
                subtitle={t('planFeatures')}
            />

            {/* Centered flex layout */}
            <div className="flex flex-wrap justify-center gap-6 mt-6 max-w-6xl mx-auto">
                {planKeys.map((planKey) => {
                    const plan = mockSubscriptionPlans[planKey];
                    const isCurrentPlan = plan.name === currentSubscriptionLevel;

                    return (
                        <div
                            key={plan.name}
                            className={`rounded-lg overflow-hidden transition-shadow duration-300 w-full sm:w-[300px] md:w-[350px] ${isCurrentPlan
                                ? 'bg-gradient-to-br from-gray-300 to-gray-600 shadow-xl ring-2 ring-gray-500 text-gray-900 dark:text-white'
                                : 'bg-gray-100 dark:bg-gray-800 text-gray-900 dark:text-white'
                                }`}




                        >
                            {/* Header */}
                            <div className="p-4 text-center font-bold text-lg rounded-t-md text-transparent bg-clip-text bg-gradient-to-br from-gray-500 to-gray-700">
                                {plan.name}
                            </div>



                            {/* Feature List */}
                            <div className="px-4 py-2 space-y-3">
                                {features.map((feature) => (
                                    <div
                                        key={feature.key}
                                        className={`border-b border-dotted border-gray-400 py-2 text-center text-sm rounded-md ${isCurrentPlan
                                            ? 'bg-green-50 text-green-800 font-semibold shadow-sm ring-1 ring-green-200'
                                            : 'text-gray-700 dark:text-gray-300'
                                            }`}
                                    >
                                        <span className="block font-medium">
                                            {t(feature.label)}
                                        </span>
                                        <span>{formatLimit(plan[feature.key])}</span>
                                    </div>
                                ))}
                            </div>

                            {/* Action Button */}
                            <div className="px-4 py-4 text-center">
                                <button
                                    onClick={() => handleSelectPlan(plan.name)}
                                    disabled={isCurrentPlan}
                                    className={`w-full py-2 rounded-lg font-semibold transition-all duration-300 ${isCurrentPlan
                                        ? 'bg-white text-green-700 border border-green-400 cursor-not-allowed shadow ring-1 ring-green-300'
                                        : 'bg-green-600 text-white hover:bg-green-700 shadow-md'
                                        }`}
                                >
                                    {isCurrentPlan ? t('currentPlan') : t('selectPlan')}
                                </button>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default SubscriptionPlans;
